import { map } from 'rxjs/operators';
import { AppConstant } from 'src/app/config/app.constant';
import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { APIs } from '../config/api.constant';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  emailList: string[] = [];
  constructor(private apiService: ApiService) { }
  getCoAdmins(): Observable<any> {
    return this.apiService.get(APIs.getCoAdmins, { id: Number(localStorage.getItem(AppConstant.localStorage.claAdminId)), parkId: localStorage.getItem('parkId') }).pipe(map(response => {
      console.log('coadmins ', response);
      return response.list;
    }));
  }

  getParkiteCoAdmins(): Observable<any> {
    return this.apiService.get(APIs.getParkiteCoAdmin, { id: Number(localStorage.getItem(AppConstant.localStorage.claAdminId)) , parkId: localStorage.getItem('parkId') }).pipe(map(response => {
      console.log('coadmins ', response);
      return response.list;
    }));
  }

  getAdminData() {
    return this.apiService.get(APIs.getAdmin, { id: btoa(localStorage.getItem(AppConstant.localStorage.claId)) }).pipe(map(response => {
      console.log('admins ', response);
      localStorage.setItem(AppConstant.localStorage.userDetails, JSON.stringify(response.data));
      localStorage.setItem(AppConstant.localStorage.userId, JSON.stringify(response.data.id));
      return response.data;
    }));
  }

  getParkiteAdmin() {
    console.log(btoa(localStorage.getItem('claId')))
    return this.apiService.get(APIs.getParkiteAdmin, { id: btoa(localStorage.getItem('claId')) }).pipe(map(response => {

      return response;
    }))
  }

  getAdminDataProfile() {
    return this.apiService.get(APIs.getAdmin, { id: btoa(localStorage.getItem(AppConstant.localStorage.claAdminId)) }).pipe(map(response => {
      console.log('admins ', response);
      localStorage.setItem(AppConstant.localStorage.userDetails, JSON.stringify(response.data));
      localStorage.setItem(AppConstant.localStorage.userId, JSON.stringify(response.data.id));
      return response.data;
    }));
  }
  getParkiteAdminDataProfile() {
    return this.apiService.get(APIs.getCLAParkiteAdmin, { id: btoa(localStorage.getItem(AppConstant.localStorage.claAdminId)) }).pipe(map(response => {
      console.log('admins ', response);
      localStorage.setItem(AppConstant.localStorage.userDetails, JSON.stringify(response.data));
      localStorage.setItem(AppConstant.localStorage.userId, JSON.stringify(response.data.id));
      return response.data;
    }));
  }

  addEmployee(requestData): Observable<boolean> {
    const paramObj = {
      ...requestData
    }
    if (paramObj.id == 0) {
      return this.apiService.post(APIs.addCoADmin, paramObj, '').pipe(map(response => {
        console.log('coadmins ', response);
        return response;
      }));
    }
    else {
      return this.apiService.put(APIs.updateCLACoADmin, paramObj, '').pipe(map(response => {
        console.log('coadmins ', response);
        return response;
      }));
    }
  }

  saveComissionDetails(requestData): Observable<boolean> {
    return this.apiService.post(APIs.addGstDetails, requestData, '').pipe(map(response => {
      console.log('Save Comission ', response);
      return response;
    }));
  }

  addParkiteEmployee(requestData): Observable<boolean> {
    const paramObj = {
      ...requestData
    }
    if (paramObj.id == 0) {
      return this.apiService.post(APIs.addParkiteCoADmin, paramObj, '').pipe(map(response => {
        console.log('coadmins ', response);
        return response;
      }));
    }
    else {
      return this.apiService.put(APIs.updateCLAParkiteCoADmin, paramObj, '').pipe(map(response => {
        console.log('coadmins ', response);
        return response;
      }));
    }
  }

  updateUserAccessPoint(userData): Observable<boolean> {
    const data = {
      accessPointList: userData.accessPointList,
      sendEmail: true,
      userId: userData.userId
    };
    return this.apiService.post(APIs.updateUserAccessPoint, data, '').pipe(map(response => {
      return response;
    }));

  }

  getUserAccessPointList(id): Observable<any> {
    console.log('test ', new Date().getSeconds());

    const param = {
      id: id
    }
    return this.apiService.get(APIs.getUserAccessPoints, param).pipe(map(response => {
      return response;
    }))
  }

  removeCoAdmin(id): Observable<any> {
    return this.apiService.put(APIs.removeCoADmin + "?id=" + id, {}).pipe(map(response => {
      return response;
    }))
  }

  removeParkiteCoAdmin(id): Observable<any> {
    return this.apiService.put(APIs.removeParkiteCoADmin + "?id=" + id, {}).pipe(map(response => {
      return response;
    }))
  }

  getClaCredit() {

    return this.apiService.get(APIs.getclaCredit).pipe(map(response => {
      return response;
    }))
  }

  // getAdminId(): Observable<any> {
  //   this.url = APIs.getUserDetail;
  //   const paramObj = {
  //   };
  //   return this.apiService.get(this.url, paramObj).pipe(map(response => {
  //     localStorage.setItem(AppConstant.localStorage.tenantId, response.data.t0200OrgEmployees[0]?.tenantId);
  //   }));
  // };

  sendEmail(emailData) {
    return this.apiService.post(APIs.sendEmails, emailData).pipe(map(response => {
      return response;
    }))
  }

  getEmailList(): string[] {
    return this.emailList
  }

  setEmailList(emailList: string[]) {
    this.emailList = emailList
  }

  changeActivation(activationStatus: boolean, userId: number): Observable<any> {
    return this.apiService.post(APIs.changeActivation, { userId: userId, isActive: activationStatus }).pipe(map(response => {
      return response;
    }))
  }

  getCompaniesList() {
    let locationId = localStorage.getItem("locationId") ?? 1;
    return this.apiService.get(APIs.getCompanyList + '?locationId=' + locationId).pipe(map(response => {
      return response.list;
    }))
  }

}
